import { useOverlayState } from "@heroui/react";
import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "@/src/common/components/ui";

interface PendingApprovalModalProps {
	isOpen: boolean;
	onSignOut: () => void;
}

export function PendingApprovalModal({ isOpen, onSignOut }: PendingApprovalModalProps) {
	const { t } = useTranslation("onboarding");

	const state = useOverlayState({ isOpen, onOpenChange: () => {} });

	return (
		<Modal state={state}>
			<Modal.Backdrop isDismissable={false}>
				<Modal.Container>
					<Modal.Dialog>
						<Modal.Body className="text-center py-8">
							<div className="flex justify-center mb-4">
								<Clock className="w-10 h-10 text-foreground/40" />
							</div>
							<h2 className="text-xl font-bold mb-2">{t("pending_title")}</h2>
							<p className="text-sm text-foreground/50 mb-6">{t("pending_message")}</p>
							<Button variant="outline" fullWidth onPress={onSignOut}>
								{t("pending_sign_out")}
							</Button>
						</Modal.Body>
					</Modal.Dialog>
				</Modal.Container>
			</Modal.Backdrop>
		</Modal>
	);
}
